<template>
  <v-app>
    <div class="app">
      <NavigationBar />
      <router-view></router-view>
      <QuickContacts />
      <Header />
      <TitleImage />
      <Pages />
      <Footer />
    </div>
  </v-app>
</template>

<script>
// Hlavní komponenty
import Header from "./components/PageParts/Header/Header";
import Footer from "./components/PageParts/Footer/Footer";
import QuickContacts from "./components/PageParts/QuickContacts/QuickContacts";
import Pages from "./components/PageParts/Pages/Pages";
import TitleImage from "./components/PageParts/TitleImage/TitleImage";
import NavigationBar from "./components/PageParts/Header/components/NavigationBar";
// Axios
import { mapMutations, mapActions } from "vuex";
export default {
  name: "app",
  components: {
    Header,
    Footer,
    QuickContacts,
    Pages,
    TitleImage,
    NavigationBar
  },
  created() {
    this.getCars();
  },
  methods: {
    ...mapActions(["getCars"]),
    ...mapMutations
  }
};
</script>

<style lang="scss">
@import "./scss/global.scss";

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
}

button:focus {
  outline: none;
}

body {
  margin: 0;
  padding: 0;
}

.app {
  margin: 0 auto;
  padding: 0;
  font-family: "Open Sans", Verdana, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #292929;
}

@media (min-width: $min-width-extended) {
  body {
    min-width: 53rem;
  }
}
</style>
